import { toast } from 'material-react-toastify';

import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { userKeys } from '@/lib/query/keys/user';
import { UserHub } from '@addmile/backend-client';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

export const useListUsers = (email: string | null, refetchInterval = 15000) => {
  return useQuery<UserHub[]>({
    queryKey: [...userKeys.lists(), email],
    queryFn: async () => {
      try {
        const token = await getAuthToken();
        if (email) {
          const { data } = await hubApi.listUsersByEmailHub(email, withAuthHeader(token));
          return data as UserHub[];
        }

        const {
          data: { users },
        } = await hubApi.getUsersHub(withAuthHeader(token));

        return users;
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        Sentry.captureException(`Failed to fetch users: ${errorMessage}`);
        toast.error(`Failed to fetch users: ${errorMessage}`);
        return [];
      }
    },
    refetchInterval,
    staleTime: 10000,
    refetchIntervalInBackground: true,
  });
};
